export default "__VITE_ASSET__BlhyFilR__"